import {SmartComponent} from "smart-component-js";
import AdvancedSearchPanel from "../utils/AdvancedSearchPanel";

class SearchResultsComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.advancedSearchElement = this.element.querySelector('.advanced-search-panel');
        this.input = this.element.querySelector('.advanced-search-bar__input');
        this.resultsWrapper = this.element.querySelector('.search-results__list');
        this.searchButton = this.element.querySelector('.advanced-search-bar__button');
        this.searchIngredientButton = this.element.querySelector('.search-ingridient__button');
        this.showMore = this.element.querySelector('.search-results__show-more');
        this.type = this.element.dataset.type;
        this.params = {page: 1, site: this.element.dataset.site, locale: this.element.dataset.locale};
        this.init();
    }

    getEndpointParams() {
        let params = [];
        params.push(`page=${this.params.page}`);
        params.push(`site=${this.params.site}`);
        params.push(`locale=${this.params.locale}`);
        if (this.params.keyword) params.push(`keyword=${this.params.keyword}`);
        if (this.params.diff) params.push(`diff=${this.params.diff}`);
        if (this.params.course) params.push(`course=${this.params.course}`);
        if (this.params.time) params.push(`time=${this.params.time}`);
        if (this.params.ing) params.push(`ing=${this.params.ing}`);
        if (this.params.cat) params.push(`cat=${this.params.cat}`);
        return params.join('&');
    }


    search(refreshCategories = true) {
        this.element.classList.add('loading');
        if(refreshCategories) this.params.cat = null;
        youserxp.ajax(`/api/1.0/henkel/${this.type}/search?` + this.getEndpointParams(), {
            method: 'GET',
            auth: false
        }).then((data) => {
            const list = data.body.articlesResult || data.body;
            refreshCategories && data.body.filters && this.appendCategories(data.body.filters);
            this.appendResults(list?.articles || list?.recipes);
            this.toggleShowMoreButton(list?.count);
            window.iconManager?.processIconAsync(this.resultsWrapper);
            this.element.classList.remove('loading');
        }).catch((err) => console.error(err));

    }

    searchForCategories(el) {
        if (el.classList.contains('search-results__category--active')) return;
        this.element.querySelector('.search-results__category--active').classList.remove('search-results__category--active');
        el.classList.add('search-results__category--active');
        this.params.cat = el.id >= 0 ? el.id : null;
        this.resultsWrapper.innerHTML = '';
        this.params.page = 1;
        this.search(false);
    }

    appendCategories(list) {
        const wrapper = this.element.querySelector('.search-results__categories');
        let html = '';
        list.forEach((el, index) => {
            const active = (el.id === -1) ? 'search-results__category--active' : '';
            html += `<li class="search-results__category ${active}" id="${el.id}">${el.label} (${el.count})</li>`;
        });
        wrapper.innerHTML = html;
        this.addCategoriesListener();
    }


    addCategoriesListener() {
        const categories = this.element.querySelectorAll('.search-results__category');
        categories.forEach((el) => {
            el.addEventListener('click', () => this.searchForCategories(el));
        });
    }

    appendResults(results = []) {
        let html = '';
        results.forEach((el) => {
            html += `<a class="search-results__item" href="${el.url}">
                <div class="search-results__item-image">
                    <img src="${el.image}" alt="${el.title}" />
                </div>
                <div class="search-results__item-content">
                    <span class="search-results__item-category">${el.subCategory?.toUpperCase()}</span>
                    <h2 class="search-results__item-title">${el.title}</h2>
                    <p class="search-results__item-description">${el.subtitle || ''}</p>
                    
                    <div class="search-results__item-info">
                    
                        ${el.readingTime ? `
                            <div class="search-results__info-item">
                                <icontemplate icon="clock" size="small" clazz="icon"></icontemplate>
                                <span class="search-results__info-text">LEGGI IN ${el.readingTime}'</span>
                            </div>` : ''}
                        ${el.difficulty ? `
                            <div class="search-results__info-item">
                                <icontemplate icon="fork" size="small" clazz="icon"></icontemplate>
                                <span class="search-results__info-text">${el.difficulty}</span>
                            </div>` : ''}
                        ${el.courseType ? `
                            <div class="search-results__info-item">
                                <icontemplate icon="plate" size="small" clazz="icon"></icontemplate>
                                <span class="search-results__info-text">${el.courseType}</span>
                            </div>` : ''}
                        ${el.time ? `
                            <div class="search-results__info-item">
                                <icontemplate icon="clock" size="small" clazz="icon"></icontemplate>
                                <span class="search-results__info-text">${el.time}</span>
                            </div>` : ''}
                    </div>
                </div>
            </a>`;
        });

        if(!results.length) html += `<div class="search-results__empty">Nessun risultato</div>`;
        this.resultsWrapper.insertAdjacentHTML('beforeend', html);
    }

    getQueryParams() {
        let params = new URLSearchParams(document.location.search);
        this.params.keyword = params.get("keyword");
        this.params.diff = params.get("diff");
        this.params.course = params.get("course");
        this.params.time = params.get("time");
        this.params.ing = params.get("ing");
        let name = params.get("keyword");
        this.input.value = name ? decodeURIComponent(name) : '';
        this.params.keyword = this.input.value;
        this.search();
        if(this.type === 'recipe') this.advancedSearch.setActiveFilters(this.params);
    }

    addSearchButtonListener() {
        this.searchIngredientButton?.addEventListener('click', () => this.getFiltersAndSearch());
        this.searchButton.addEventListener('click', () => this.getFiltersAndSearch());
        this.input.addEventListener('keypress', (e) => {
            if (e.key !== 'Enter') return;
            this.getFiltersAndSearch();
        });
    }


    getFiltersAndSearch() {
        this.resultsWrapper.innerHTML = '';
        if(this.type === 'recipe') this.params = {...this.params, ...this.advancedSearch.getActiveFilters()};
        this.params.keyword = this.input.value;
        this.params.page = 1;
        this.search();
    }


    toggleShowMoreButton(count) {
        const nextPage = count > (this.params.page * 6);
        nextPage ? this.showMore.classList.remove('hidden') : this.showMore.classList.add('hidden');
    }

    addShowMoreListener() {
        this.showMore.addEventListener('click', () => {
            this.params.page = this.params.page + 1;
            this.search(false);
        });
    }

    init() {
        this.advancedSearch = new AdvancedSearchPanel(this.advancedSearchElement);
        this.getQueryParams();
        this.addSearchButtonListener();
        this.addShowMoreListener();
    }
}

export default SearchResultsComponent;
